module.exports = __webpack_public_path__ + "static/media/GLOSSINDUSTRY.0b6de7e2.txt";